import { EnergyConsumption } from '@_models/vehicleInfo/energyUsage/energy-consumption.model';

export class EnergyUsage {
	id!: number;
	electric: EnergyConsumption;
	diesel: EnergyConsumption;
	gas: EnergyConsumption;
	electricComp: EnergyConsumption;
}
